import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useProjectFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      projects: [],
      projectAdmins: [],
      projectRecordStatusId: null,
      projectBillingTypes: [],
      projectStatuses: [],
      projectTags: [],
      projectGroups: [],
      projectTypes: [],
      projectPractices: [],
      projectBusinessUnits: [],
      projectSalesRepresentatives: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const projectSearchParamsConfig = useMemo(
    () => ({
      projects: searchParamsConfig.projects,
      projectAdmins: searchParamsConfig.projectAdmins,
      projectRecordStatusId: searchParamsConfig.projectRecordStatusId,
      projectBillingTypes: searchParamsConfig.projectBillingTypes,
      projectStatuses: searchParamsConfig.projectStatuses,
      projectTags: searchParamsConfig.projectTags,
      projectGroups: searchParamsConfig.projectGroups,
      projectTypes: searchParamsConfig.projectTypes,
      projectPractices: searchParamsConfig.projectPractices,
      projectBusinessUnits: searchParamsConfig.projectBusinessUnits,
      projectSalesRepresentatives: searchParamsConfig.projectSalesRepresentatives,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback((filters) => {
    return {
      projectId: filters.projects?.map((v) => v.id),
      projectAdminId: filters.projectAdmins?.map((v) => v.id),
      projectBillingTypeId: filters.projectBillingTypes?.map((v) => v.id),
      projectBusinessUnitId: filters.projectBusinessUnits?.map((v) => v.id),
      projectGroupId: filters.projectGroups?.map((v) => v.id),
      projectPracticeId: filters.projectPractices?.map((v) => v.id),
      projectRecordStatusId: filters.projectRecordStatusId ?? undefined,
      projectSalesRepresentativeId: filters.projectSalesRepresentatives?.map((v) => v.id),
      projectStatusId: filters.projectStatuses?.map((v) => v.id),
      projectTagId: filters.projectTags?.map((v) => v.id),
      projectTypeId: filters.projectTypes?.map((v) => v.id),
    };
  }, []);

  const mapClickThroughParams = useCallback(
    (filters) => ({
      projectId: filters.projects?.map((v) => v.id),
      projectAdminId: filters.projectAdmins?.map((v) => v.id),
      projectRecordStatusId: filters.projectRecordStatusId ?? undefined,
      projectBillingTypeId: filters.projectBillingTypes?.map((v) => v.id),
      projectStatusId: filters.projectStatuses?.map((v) => v.id),
      projectTagId: filters.projectTags?.map((v) => v.id),
      projectGroupId: filters.projectGroups?.map((v) => v.id),
      projectTypeId: filters.projectTypes?.map((v) => v.id),
      projectPracticeId: filters.projectPractices?.map((v) => v.id),
      projectBusinessUnitId: filters.projectBusinessUnits?.map((v) => v.id),
      projectSalesRepresentativeId: filters.projectSalesRepresentatives?.map((v) => v.id),
    }),
    [],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: projectSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams }),
    [filters, projectSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams],
  );
}
